import habo from 'habo';
import {captureException} from '@sentry/vue';
import {useUserInfo} from '@/hooks/useUserInfo';
import {useDeviceInfo} from '@/hooks/useDeviceInfo';
import useUa, {XApp} from '@/hooks/useUa';
import {useHaboInfo} from '@/hooks/useHaboInfo';
import {EventIdType, getEventId} from '@/enum/haboEventId';
import {haboClickLogger, haboTimeEndLogger, perfLogger} from '@/utils/logger';
import {getUrlSearch} from '@/utils/getUrlSearch';
import {getFmp} from '@/utils';
import {timeReportIOS} from '@/bridge';

const {userId} = useUserInfo();
const {cmsCode, contentCode} = useHaboInfo();
const {did} = useDeviceInfo();

const {isXApp, outOpenParams} = useUa();
// pageType 区分品类学习页(4)还是精选学习页(9)
// previewSource 来源 1.端内 2.端外 3.社区 4.搜索
const {pageType: page_type = 4, previewSource: preview_source = 1} = getUrlSearch();
enum BizName {
  isGaotuApp = 'gt-gaotu',
  isGongkaoApp = 'gt-gongkao',
  isTutuApp = 'tutu-app',
  isJingpinApp = 'gt-jingpin',
  isXinliApp = 'gt-xinli',
  isKetangApp = 'gt-ketang',
}
enum AppBizName {
  'gaotu' = 'gt-gaotu',
  'gongkao' = 'gt-gongkao',
  'tutu' = 'tutu-app',
  'jingpin' = 'gt-jingpin',
  'xinli' = 'gt-c-xinli',
  'ketang' = 'tutu-gtketang-wap',
}
// 客户端内
let biz_name: string = BizName[(Object.keys(isXApp) as (keyof XApp)[]).find((item: keyof XApp) => isXApp[item])!];

if (outOpenParams.app) {// 端外打开的埋点参数从 url app 中取得
  if (outOpenParams.app === 'tutu') {// 途途 App 区分了端内外 biz_name
    biz_name = 'tutu-m';
  }
  else if (outOpenParams.app === 'jingpin') {
    biz_name = 'gt-jingpin-m';
  }
  else if (outOpenParams.app === 'ketang') {
    biz_name = 'tutu-gtketang-app';
  }
  else {
    biz_name = AppBizName[outOpenParams.app];
  }
}

try {// habo 初始化
  habo.setConfig({
    NAME: biz_name, // 产品线名称 biz_name
    VERB: 'get',
    TIMEOUT: '15000',
    DELAY: false,
    APPNID: 'baijia.gtbg.fe.bj.bamboo-study-info-fe'
  });
}
catch (error) {
  captureException(new Error('哈勃初始化失败'));
}

// 点击浏览上报
export const haboClickReport = (eventName: keyof EventIdType, other = {}) => {
  const eventId = getEventId(eventName);
  const params = {
    eventId,
    did, // 设备 id
    page_type,
    preview_source, // 预览来源 1.端内 2.端外 3.社区 4.搜索
    subject_id: `[${cmsCode}]`, // 二级品类 id
    category_id: contentCode, // 内容品类 id
    user_id: userId,
    ...other
  };
  habo.click(params);
  haboClickLogger(eventId, params);
};

// 时长上报
const timeMap: { [eventId: number]: number } = {};
export const haboTimeStart = (eventName: keyof EventIdType, other = {}) => {
  const eventId = getEventId(eventName);
  timeMap[eventId] = +new Date();
  timeReportIOS(eventName, {
    did,
    page_type,
    subject_id: `[${cmsCode}]`, // 二级品类 id
    category_id: contentCode, // 内容品类 id
    user_id: userId,
    ...other
  });
};

export const haboTimeEnd = (eventName: keyof EventIdType, other = {}) => {
  const eventId = getEventId(eventName);
  const start = timeMap[eventId];
  timeMap[eventId] = 0;
  if (!start) {
    return -1;
  }

  const elapsed = +new Date() - start;
  const params = {
    eventId,
    did,
    page_type,
    stay_time: elapsed,
    // elapsed,
    subject_id: `[${cmsCode}]`, // 二级品类 id
    category_id: contentCode, // 内容品类 id
    user_id: userId,
    ...other
  };
  habo.click(params);
  haboTimeEndLogger(eventId, params);
};

// @/plugins/haboConfig
export const haboPerf = (type: 'fmp') => {
  if (type === 'fmp') {
    const fmp = getFmp();
    if (fmp) {
      habo.perf({
        fmp
      });
      perfLogger();
    }
  }
};
